import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import React, { Component } from 'react'
import { Column } from 'react-formio/lib/types';
import { connect } from 'react-redux';
import Service from '../../services';
import { baseUrlAdmin } from '../../store/apiConstants';
import SvgViewer from '../customComponents/svgViewer';
import LoadingComponent from '../loadingComponent';
import Authentication from '../session'
import CreateFee from './createFee';


import {
    getAllCourseDetails
} from './../../store/actions';
import { userAssignedBoards } from '../../store/selectors/userAssignedBoards';
import { Menu } from 'primereact/menu';
import { Tooltip } from 'primereact/tooltip';
import { Checkbox } from 'primereact/checkbox';
import { InputText } from 'primereact/inputtext';
import withRouter from '../lib/withRouter';


const items = [
    { label: 'Organization' },
    { label: 'Application Fees', className: 'ma-active-item' }
];

const home = { icon: 'pi pi-home' }

class ApplicationFee extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            showCreateFee: false,
            applicationFees: [],
            globalFilter: null,
            showSearch: false,
            columns: [{ columnName: '', isVisible: false, id: '' }]
        }

        this.service = new Service()
    }


    componentDidMount() {
        // console.log('qww', this.props)
        this.getapplicationFees()
    }

    getapplicationFees = () => {

        this.setState({ isLoading: true })
        let url = `${baseUrlAdmin}/application-fee`;
        this.service.get(url, true).then(res => {
            if (res?.status && res?.res?.status) {
                // console.log(res, 'res');
                this.setState({
                    isLoading: false,
                    applicationFees: res?.res?.data
                })
            } else {
                this.setState({
                    isLoading: false
                })
                this.toast.show({ severity: 'error', summary: 'Some error occured', detail: res.errMessage, life: 3000 });
            }
        }).catch(err => {
            console.log(err, 'err')
            this.setState({
                isLoading: false
            })
            this.toast.show({ severity: 'error', summary: 'Some error occured', detail: err.message, life: 3000 });
        })
    }


    rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                <h4 className='ma-tab-title'>Application Fees</h4>
            </React.Fragment>
        )
    }
    leftToolbarTemplate() {
        return (
            <React.Fragment>
                <BreadCrumb model={items} home={home} />
            </React.Fragment>
        )
    }

    showEditRoleDialog = (editData) => {

        this.setState({
            editFee: editData,
            showCreateFee: true,
        });
    }

    editTemplate = (rowData, { rowIndex }) => {
        return (<>
            <div className="p-d-flex ma-mlr10 ">
                <span data-pr-tooltip="Edit Role" data-pr-position="bottom" className={`ma-ml10 ar${rowIndex}`} onClick={() => this.showEditRoleDialog(rowData)} >
                    <SvgViewer className='ma-icon-svg ma-pointer' src='new-assets/edit.svg' width="20" height="20" />
                </span>
            </div>
        </>
        );
    }

    onClickAddFee = () => {

        this.setState({
            showCreateFee: true
        })
    }

    onClose = (create) => {
        this.setState({
            showCreateFee: false, editFee: null
        });

    }


    onSaveOrUpdate = (isUpdate) => {
        this.toast.show({ severity: 'success', summary: 'Saved', detail: `Admission Type ${isUpdate ? 'updated' : 'created'} successfuly`, life: 3000 });
        this.setState({
            showCreateFee: false, editData: null
        }, this.getapplicationFees)
    }

    exportCSV = () => {
        this.dt.exportCSV();
    }

    onColumnClick = (column) => {
        let columns = this.state.columns.map(c => {
            if (column.id == c.id) {
                c.isVisible = !c.isVisible;
            }
            return c;
        });
        this.setState({
            columns
        });
    }


    render() {
        const header = (
            <div className="flex justify-content-between bg-white">
                <div className="flex">
                    <h4>Application Fees</h4>
                    {this.state.showSearch && <InputText placeholder="Search" className="ml-4 h-2rem w-15rem" onChange={(e) => this.setState({ globalFilter: e.target.value })} />}

                </div>

                <div className="bg-blue-50 cursor-pointer mb-2 border-round">
                    <ul className="flex gap-5 mr-6">
                        <i data-pr-tooltip="Search" data-pr-position="bottom" className="pi pi-search ma-tbl-icon ma-tbl-srch" onClick={(e) => { this.setState({ showSearch: !this.state.showSearch }) }}></i>
                        <Tooltip className="table-li-tooltip" autoHide={false} target=".ma-tbl-srch" />
                        {/* <i data-pr-tooltip="Filter" data-pr-position="bottom" className="pi pi-filter ma-tbl-icon ma-tbl-fi"></i>
                        <Tooltip className="table-li-tooltip" target=".ma-tbl-fi" /> */}
                        {/* <i data-pr-tooltip="View Columns"
                            onClick={(event) => this.menu.toggle(event)}
                            data-pr-position="bottom" className="pi pi-sort-alt ma-tbl-icon ma-tbl-sort"></i>
                        <Tooltip className="table-li-tooltip" target=".ma-tbl-sort" /> */}
                        <i data-pr-tooltip="Download" data-pr-position="bottom" className="pi pi-download ma-tbl-icon ma-tbl-dwnld" onClick={this.exportCSV}></i>
                        <Tooltip className="table-li-tooltip" target=".ma-tbl-dwnld" />
                    </ul>
                </div>
                <Menu
                    className='table-filter-w'
                    model={[
                        {
                            template: (<div className='table-filter'>
                                <h4 className="filter-title">View Columns</h4>
                                <ul>
                                    {this.state.columns.map((column) => {
                                        return <div onClick={() => this.onColumnClick(column)}><Checkbox inputId={column.id}
                                            checked={column.isVisible}
                                        ></Checkbox>
                                            <label htmlFor={column.id} className="p-checkbox-label p-name">{column.columnName}</label>
                                        </div>
                                    })}
                                </ul>
                            </div>)
                        }]
                    }
                    popup
                    ref={el => this.menu = el} />
            </div>
        );
        return (<>
            <div>
                <div className="-mt-4">
                    <Toolbar className="p-breadcrumb" left={this.leftToolbarTemplate} right={this.rightToolbarTemplate}></Toolbar>
                </div>
            </div>
            <div className='ma-main'>
                <Button label="+ Add Fee" className='p-button-raised my-3' onClick={this.onClickAddFee} />
                <div className='card'>
                    <DataTable ref={(el) => this.dt = el}
                        value={this.state.applicationFees || []}
                        dataKey="id"
                        paginator
                        rows={10}
                        showGridlines
                        responsiveLayout="scroll"
                        rowsPerPageOptions={[5, 10, 25, 50, 100]}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                        globalFilter={this.state.globalFilter}
                        header={header}
                    >
                        <Column field="boardName" header="Board Name" />
                        <Column field="className" header="Class Name" />
                        <Column field="admissionType" header="Admission Type" />
                        <Column field="applicationFee" header="Application Fee" />
                        <Column field="registrationFee" header="Registration Fee" />
                        <Column header="Actions" body={this.editTemplate} ></Column>
                    </DataTable>
                    {this.state.showCreateFee &&
                        <CreateFee
                            applicationFees={this.state.applicationFees}
                            editFee={this.state.editFee}
                            onClose={this.onClose}
                            onSaveOrUpdate={this.onSaveOrUpdate}
                        />
                    }
                </div>
            </div>
            <Toast ref={(el) => this.toast = el} position="bottom-right" />
            {(this.state.isLoading || this.props.isCoursesLoading) && <LoadingComponent />}
        </>

        )
    }
}


const mapStateToProps = (state) => ({
    boards: userAssignedBoards(state, 'activeBoards'),
    isLoading: state.boardsData.loading,
    admissionCourses: state.coursesData?.courses || [],
    isCoursesLoading: state.coursesData?.loading,

});


export default connect(mapStateToProps, {
    getAllCourseDetails
})(Authentication(withRouter(ApplicationFee)));
